import React, {Fragment} from "react";
import classNames from "classnames";
import { Tooltip } from 'react-tippy';
import {set, get} from '../../../utils/dotutils';
import Icon from "../Icon";

export class EditorField extends React.Component {

    state = {
        editing: false
    }

    constructor(props) {
        super(props);
        this.state.editing = !!this.props.active;
        if (this.state.editing) {
            this.bindDocumentEditListener();
        } else {
            this.unbindDocumentEditListener();
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.active !== this.state.editing) {
            this.setState({
                editing: !!this.props.active
            }, () => {
                if (this.state.editing) {
                    this.bindDocumentEditListener();
                } else {
                    this.unbindDocumentEditListener();
                }
            });
        }
    }

    onKeyDown = (event, field, value) => {
        // UP
        if (event.which === 38) {
            if (this.props.up) {
                this.props.up(this.props.rowIndex, this.props.field);
            }
        }
        // DOWN
        if (event.which === 40) {
            if (this.props.down) {
                this.props.down(this.props.rowIndex, this.props.field);
            }
        }
        // ENTER TAB
        if (event.which === 13 || event.which === 9) {
            if (this.props.right && event.which === 9) {
                this.props.right(this.props.rowIndex, this.props.field);
            }
            if (event.which === 13) {
                this.switchCellToViewMode();
            }
            if (this.props.down) {
                this.props.down(this.props.rowIndex, this.props.field);
            }
        }
        // ESC
        if (event.which === 27) {
            if (this.props.cancel) {
                this.props.cancel(this.props.rowIndex, this.props.field);
            }
        }
        if (this.props.onKeyDown) {
            this.props.onKeyDown(event, field, value);
        }
    }

    onClick = (e) => {
        if (this.props.editor) {
            const editor = this.editor();
            if (editor) {
                e.preventDefault();
                e.stopPropagation();
            }
            this.setState({
                editing: true
            });
            if (this.props.onEdit) {
                this.props.onEdit(this.props.rowIndex, this.props.field);
            }

            if (this.documentEditListener)
                this.cellClick = true;
            else
                this.bindDocumentEditListener();
            if (editor) {
                return false;
            }
        }
    }

    bindDocumentEditListener = () => {
        if (!this.documentEditListener) {
            this.documentEditListener = (event) => {
                if (!this.cellClick) {
                    this.switchCellToViewMode();
                }

                this.cellClick = false;
            };

            document.addEventListener('click', this.documentEditListener);
        }
    }

    closeCell = () => {
        this.setState({
            editing: false
        });
        if (this.props.onEditClose) {
            this.props.onEditClose(this.props.rowIndex, this.props.field);
        }
        this.unbindDocumentEditListener();
    }

    body = () => {
        let data = null;
        if (this.props.body) {
            data = this.props.body(this.props.rowData, this.props);
        } else {
            data = get(this.props.rowData, this.props.field);
        }
        const index = this.props.rowIndex;
        return (this.props.rowOrder) ? <Fragment>
            <i className="drag p-table-reorderablerow-handle pi pi-bars sort-icon pull-right" />
            <i className="pi pi-chevron-down sort-icon pull-right" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (this.props.sortOrder > 0) {
                    this.onReorder(index, index + 2);
                } else {
                    this.onReorder(index, index + 2);
                }
                return false;
            }}/>
            <i className="pi pi-chevron-up sort-icon pull-right" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (this.props.sortOrder > 0) {
                    this.onReorder(index, index - 1);
                } else {
                    this.onReorder(index, index - 1);
                }
                return false;
            }}/>
            {data}
        </Fragment> : data;
    }

    onReorder = (draggedRowIndex, droppedRowIndex) => {
        if (this.props.onRowReorder) {
            this.props.onRowReorder({
                dragIndex: draggedRowIndex,
                dropIndex: droppedRowIndex
            })
        }
    }

    editor = () => {
        if (this.props.editor) {
            return this.props.editor(this.props, get(this.props.rowData, this.props.fieldName));
        }
        return null;
    }

    switchCellToViewMode = () => {
        if (this.props.editorValidator) {
            let valid = this.props.editorValidator(this.props);
            if (valid) {
                this.closeCell();
            }
        }
        else {
            this.closeCell();
        }
    }

    unbindDocumentEditListener = () => {
        if (this.documentEditListener) {
            document.removeEventListener('click', this.documentEditListener);
            this.documentEditListener = null;
        }
    }

    onLeave = (e) => {
        this.props.onLeave && this.props.onLeave(e, this.props.field, get(this.props.rowData, this.props.fieldName), this.props.rowData, this.props.rows);
    }

    onHover = (e) => {
        this.props.onHover && this.props.onHover(e, this.props.field, get(this.props.rowData, this.props.fieldName), this.props.rowData, this.props.rows);
    }

    render() {

        let tooltip = {};
        if (typeof(this.props.tooltip) === "object" && !(this.props.tooltip || {}).props) {
            tooltip = {...this.props.tooltip, position: (this.props.tooltip || {}).position || "top", disabled: (this.props.tooltip || {}).disabled};
        } else {
            const html = this.props.tooltip instanceof Function ? this.props.tooltip(get(this.props.rowData, this.props.fieldName), this.props.rowData, this.props.rowIndex, {...this.props}) : this.props.tooltip;
            tooltip = {position: "top"};
            if (html) {
                tooltip.html = html;
            } else {
                tooltip = {};
            }
        }

        const isTippy = !!Object.keys(tooltip).length;

        const Tag = isTippy ? Tooltip : "div";

        const columnClassName = classNames(this.props.columnClassName && this.props.columnClassName(this.props.field, get(this.props.rowData, this.props.fieldName), this.props.rowData, this.props.rows, {...this.props}));
        const columnCss = this.props.columnCss && this.props.columnCss(this.props.field, get(this.props.rowData, this.props.fieldName), this.props.rowData, this.props.rows);
        if (this.state.editing && this.props.editor && !this.props.disabled) {
            const editor = this.editor();
            const className = classNames(columnClassName, "editor-field", this.props.className, {"editing": editor && this.state.editing && this.props.editor && !this.props.disabled, "has-editor": this.props.editor && !this.props.disabled && !this.state.editing});
            if (editor) {
                return (
                    <div className={className} ref={(el) => this.element = el} tabIndex="0" onClick={this.onClick} onMouseOver={this.onHover} onMouseLeave={this.onLeave}
                         onKeyDown={this.onKeyDown}>
                        <div>
                            {editor}
                        </div>
                    </div>
                );
            }
        }
        const className = classNames(columnClassName, "editor-field", this.props.className, {"has-editor": this.props.editor && !this.props.disabled && !this.state.editing});
        return (
            <div className={className} style={columnCss || {}} ref={(el) => this.element = el} onClick={this.onClick} onMouseOver={this.onHover} onMouseLeave={this.onLeave}>
                <Tag {...(isTippy ? tooltip : {})}>
                    {this.body()}
                </Tag>
            </div>
        );
    }

}

export default EditorField;